<div class="dropdown h-100 d-flex align-items-center" >
    <div class="topbar-item" [ngClass]="{'pointer-events-none': !isLoginForFirstTime}" data-offset="10px,0px" (click)="downloadItpApps.show();checkEvent($event)">
        <div [class]="customStyle" pTooltip="{{'DownloadApp' | localize}}" tooltipPosition="bottom">
            <i class="flaticon-download"></i>
        </div>
    </div>

</div>

    <div bsModal #downloadItpApps="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="downloadItpApps" id="downloadITP"
         aria-hidden="true" [config]="{backdrop: false}" (onHide)="onDownloadModalHide()">
        <div  style="background-color: #53535361;  height: 103%; margin-top: -1.75rem; padding-top: 20px; margin-bottom: -1.75rem; ">
            <div class="modal-dialog download-itp-modal-dialog modal-dialog-centered">

                <div class="modal-content">

                    <div class="card">

                        <div class="modal-header">

                            <h6 class="modal-title">
                                {{'DownloadNow' | localize}}


                            </h6>

                            <button type="button" class="close" (click)="downloadItpApps.hide()">

                                <i aria-hidden="true" class="ki ki-close"></i>

                            </button>

                        </div>

                        <div class="modal-body pt-0 pb-0">

                            <div class="p-4 download-ITP-card">
                                <div class="row">
                                    <div class="col-md-12 text-left px-8">
                                        <p class="paraFont">{{'Install' | localize}} <b>{{'InTimePRO' | localize}} </b>{{'onyouroperatingsystemtoefficientlytracktasksandactivities' | localize}}, {{'helpingyoustayorganizedandincreaseproductivity' | localize}}.</p>
                                    </div>
                                    <div class="col-md-6 px-8 mb-4 mb-md-0" *ngFor="let item of carddata; trackBy: trackByName">
                                        <div class="card card-body border shadow-sm">
                                            <div class="text-left mb-2" >
                                        <span  class="label  rounded-pill mr-3 label-inline  border border-2 justify-content-start" *ngIf="item.name =='Mico Linux Agent'">
                                            <span class="d-flex">

                                                {{'ComingSoon' | localize}}

                                            </span>

                                    </span>

                                      </div>
                                      <div class="text-left mb-2" >
                                        <span  class=" rounded-pill mr-3   justify-content-start" *ngIf="item.name !='Mico Linux Agent'">
                                       <span class="d-flex" >


                                         </span>

                                    </span>

                                      </div>
                                            <div class="text-center d-flex justify-content-center">
                                                
                                                <img class="img-fluid h-180px d-none d-md-block" [src]="item.img" />
                                            </div>
                                            <div class="text-center mt-3 mb-3 font-weight-bolder">{{item.name | localize}}</div>
                                            <div class="input-icon text-center">
                                                <button class="btn btn-primary blue text-uppercase" (click)="downloadAgentAppWindows(item)" *ngIf="item.name !='Mico Linux Agent'">
                                                     <img [src]="item.imgIcon" class="h-10px h-md-15px" />
                                                    &nbsp;
                                                    {{'Download' | localize}} 
                                                </button>
                                                <button class="btn border-secondary text-secondary text-uppercase cursor-not-allowed" *ngIf="item.name =='Mico Linux Agent'">
                                                    {{'Download' | localize}} 
                                                    &nbsp; <img [src]="item.imgIcon" class="h-10px h-md-15px d-none" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-md-12 mt-5">
                                        <div class="row">
                                            <!-- BS4 has no .visually-hidden; that left this block visible. Hide until store links are ready. -->
                                            <div class="col-md-6 d-none">
                                                <div class="d-flex align-items-center">
                                                    <div>
                                                    {{'Companionapps' | localize}}
                                                    </div>
                                                    <div>
                                                        <span class="d-flex">
                                                            <button type="button" class="btn border-secondary border-2 ml-4">
                                                                <img src="assets/common/images/login/Play_Store.png" class="img-fluid" style="max-height: 28px; width: auto;" alt="" />  &nbsp;
                                                                {{'PlayStore' | localize}}

                                                            </button>
                                                            <button type="button" class="btn border-secondary border-2 ml-4">
                                                                <img src="assets/common/images/login/App_Store.png" class="img-fluid" style="max-height: 28px; width: auto;" alt="" />  &nbsp;
                                                                {{'AppStore' | localize}}

                                                            </button>
                                                        </span>
                                                    </div>
                                                   
                                                </div>
                                            </div>
                                            <div class="col-md-12 d-flex justify-content-center justify-content-md-end">
                                                <div class="p-2 d-flex align-items-center">
                                                    <p class="text-danger mb-0"><a href="javascript:void(0)" (click)="remindMeLater(false);downloadItpApps.hide()">{{'Neveraskmeagain' | localize}}</a></p>
                                                </div>
                                                <div class="p-2">
                                                    <button (click)="remindMeLater(true);downloadItpApps.hide()" class="btn btn-outline-primary">{{'Remindmelater' | localize}}</button>
                                                </div>
                                            </div>
                                        </div>


                                    </div>


                                </div>
                            </div>

                        </div>

                    </div>
                </div>


            </div>
        </div>
     </div>
